import React, { useState, useEffect } from 'react';
import { Button, Typography, Spin, Popconfirm, Tooltip, message, notification, Tag } from 'antd';
import { CheckOutlined, StopOutlined, ArrowUpOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import coinsIcon from '../../assets/icons/notificationPooling/coins.png'
import EuroIcon from '../../assets/icons/notificationPooling/coins-euro.png'
import { useDispatch, useSelector } from 'react-redux';
import { notificationAction,notificationList, poolNotificationDetails, AdminNotificationAction } from '../../features/AutoPooling/AutoPoolingSlice';
import AutoPoolDetailsModal from '../../components/AutoPooling/AutoPoolDetailsModal';
import PoolDetailsModal from '../../components/Pooling/PoolDetailsModal';

const addThousandSeparator = (value) => {
    const number = parseFloat(value);
  
    if (isNaN(number)) {
      return '';
    }
  
    return number.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 20,
    });
  };

function formatDate(dateString) {
    const date = new Date(dateString), now = new Date();
    const [hours, minutes] = [date.getHours(), date.getMinutes()];
    const ampm = hours >= 12 ? 'PM' : 'AM', formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const yesterday = new Date(now.setDate(now.getDate() - 1));

    if (date.toDateString() === new Date().toDateString()) return `Today, ${formattedHours}:${formattedMinutes} ${ampm}`;
    if (date.toDateString() === yesterday.toDateString()) return `Yesterday, ${formattedHours}:${formattedMinutes} ${ampm}`;
    
    return `${date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}, ${formattedHours}:${formattedMinutes} ${ampm}`;
}

const { Text } = Typography;
const NotificationMainTable = ({data,currentPage, setCurrentPage,activeFilter, setActiveFilter,activeDateFilter, setActiveDateFilter,dateFilterOptions }) => {
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const [isPoolDetailsModalOpen,setIsPoolDetailsModalOpen] = useState(false);
    const { user } = useSelector((state) => state.user);
    const [poolId,setPoolId] = useState(null);
    const [notification_status, setNotification_status] = useState(null);
    const [modalKey, setModalKey] = useState(0);
    const [adminAction, setAdminAction] = useState(false);

    const [messageApi, contextHolder] = message.useMessage();
    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 3000); 
        return () => clearTimeout(timer); 
    }, []);

    const handlePoolDetailSubmit = async (pool_id,status) => {
        setPoolId(pool_id);
        console.log("status",status)
        setNotification_status(status);
        await dispatch(poolNotificationDetails({pool_id:pool_id}));
        setIsPoolDetailsModalOpen(true);
    }
    
    const { NotificationListData, NotificationActionMessage,PoolDetailsData } = useSelector((state) => state.autoPooling)

    const handlePoolDetailClose = () => {
        setIsPoolDetailsModalOpen(false);
    }


    const handlePoolRequest = async (tokenId,poolID, poolRequest) => {
        if (poolRequest === 'decline') {
            const result= user.role=="Pooling Agent" ? await dispatch(notificationAction({token_id_list:tokenId,pool_id:poolID,action:poolRequest})) : user.role=="Admin Pooling Agent" ?await dispatch(AdminNotificationAction({token_id_list:tokenId,pool_id:poolID,admin_action:poolRequest})) : null;

            if (result?.meta?.requestStatus === "fulfilled") {
                notification.success({
                  message: 'Success',
                  description: `The pool request with Pool Id: ${poolID} was Declined by you.`,
                  style: { fontSize: '12px', padding: '8px', width: '40vw' },
                });
                await dispatch(notificationList({ 
                    request_type: activeFilter, 
                    requested_page_number: currentPage,
                    period: activeDateFilter 
                }));
                await dispatch(poolNotificationDetails({pool_id:poolID}));
                setTimeout(() => {
                  notification.destroy(); 
                }, 6000);
                setModalKey((prevKey) => prevKey + 1);
              } else {
                await dispatch(notificationList({ 
                    request_type: activeFilter, 
                    requested_page_number: currentPage,
                    period: activeDateFilter 
                }));
                await dispatch(poolNotificationDetails({pool_id:poolID}));
                notification.error({
                  message: 'Error',
                  description: `The pool request with Pool Id: ${poolID} has not been declined. Please try Again.`,
                  style: { fontSize: '12px', padding: '8px', width: '40vw' },
                });
                setModalKey((prevKey) => prevKey + 1);
              }
            // messageApi.open({
            //     status: 'succcess',
            //     content: 'This is an error message',
            // })
        } else {
            const result= user.role=="Pooling Agent" ? await dispatch(notificationAction({token_id_list:tokenId,pool_id:poolID,action:poolRequest})) : user.role=="Admin Pooling Agent" ?await dispatch(AdminNotificationAction({token_id_list:tokenId,pool_id:poolID,admin_action:poolRequest})) : null;
            
            if (result?.meta?.requestStatus === "fulfilled") {
                notification.success({
                  message: 'Success',
                  description: `The pool request with Pool Id: ${poolID} was Approved by you.`,
                  style: { fontSize: '12px', padding: '8px', width: '40vw' },
                });
                await dispatch(notificationList({ 
                    request_type: activeFilter, 
                    requested_page_number: currentPage,
                    period: activeDateFilter 
                }));
                await dispatch(poolNotificationDetails({pool_id:poolID}));
                setTimeout(() => {
                  notification.destroy(); 
                }, 6000);
                setModalKey((prevKey) => prevKey + 1);
              } else {
                await dispatch(notificationList({ 
                    request_type: activeFilter, 
                    requested_page_number: currentPage,
                    period: activeDateFilter 
                }));
                await dispatch(poolNotificationDetails({pool_id:poolID}));
                notification.error({
                  message: 'Error',
                  description: `The pool request with Pool Id: ${poolID} has not been Approved. Please try Again.`,
                  style: { fontSize: '12px', padding: '8px', width: '40vw' },
                });
                setModalKey((prevKey) => prevKey + 1);
              }
            // messageApi.open({
            //     status: 'success',
            //     content: 'This is a success message',
            // })
        }
    }

    console.log("NotificationListData",NotificationListData)

    return (


        <div className='pooling-notification-table-container'>
            {contextHolder}
            {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                    <Spin size="large" />
                </div>
            ) : (
                NotificationListData?.notification_list?.map((item, index) => (
                    <div className={`pooling-notification-main-container ${item.current_status=="inactive" ? "inactive" : ""}`}>
                        <div className='pooling-notification-side-container'>
                            <div className={`pooling-notification-circle ${item.current_status == 'active' || item.current_status=='active_ad' ? 'pooling-notification-circle-green' : 'pooling-notification-circle-red'}`}></div>
                            <div className='pooling-notification-line'></div>
                        </div>
                        <div className='pooling-notification-table'>
                            <div className="notification-pool-header">
                                <div className="notification-title-I">
                                    <p className='notification-title-header'>Pool Request</p>
                                    <p className='notification-subtitle-header'>{formatDate(item.date_created)}</p>
                                </div>
                                <div className="notification-title-II">
                                    
                                    {/* <p>
                                        <span>Token ID: <span>{item.token_id}</span></span>
                                        <span><Text copyable={{ text: item.token_id }} /></span>
                                    </p> */}
                                    <p>
                                        <span>Pool ID: <span>{item.pool_id}</span></span>
                                        <span><Text copyable={{ text: item.pool_id }} /></span>
                                    </p>

                                    <div>
                                        <Button
                                            key={item.pool_id}
                                            className='pooling-open-details-button'
                                            onClick={() => handlePoolDetailSubmit(item.pool_id,item.pool_status)}

                                        >
                                            Open Details <ArrowUpOutlined style={{ marginLeft: 8, transform: 'rotate(45deg)' }} />
                                        </Button>
                                    </div>

                                    <Button
                                        key={item.pool_id}
                                        className={`pooling-notification-status-button pooling-notification-button ${
                                            (item.current_status === 'active' || item.current_status === 'active_ad') &&
                                            (item.pool_status.toLowerCase() === "pending" || item.pool_status.toLowerCase() === "pending admin")
                                              ? 'pooling-notification-blue'
                                              : (item.current_status === 'active' || item.current_status === 'active_ad') &&
                                                (item.pool_status.toLowerCase() === "approved" || item.pool_status.toLowerCase() === "admin approved")
                                              ? 'pooling-notification-green'
                                              : 'pooling-notification-red'
                                          }`}                                          
                                        onClick={() => console.log("filter.value")}
                                    >
                                        {item.pool_status.charAt(0)?.toUpperCase() + item.pool_status.slice(1)}
                                    </Button>
                                </div>
                            </div>

                            {item.data.message ? <div className='pool-notifications-information'>
                                <p>{item.data.message}</p>
                                
                            </div> : <br/>}

                            <div className='pooling-notifications-footer'>
                                    
                                {/* {
                                    user.role == "Pooling Agent" && item.status == 'pending' && item.current_status=="active"
                                        ?
                                        <div className='pooling-notifications-footer-container'>
                                            <Popconfirm
                                                placement="top"
                                                title="Accept Pool Request!"
                                                description="Do you really want to accept this request?"
                                                okText="Yes"
                                                cancelText="Cancel"
                                                onConfirm={() => handlePoolRequest(item.pool_id, 'approved')}
                                            >
                                                <Button
                                                    key={item.pool_id}
                                                    className='pooling-notification-status-button pooling-notification-green pooling-notification-button'
                                                    icon={<CheckOutlined />}
                                                >
                                                    Accept
                                                </Button>
                                            </Popconfirm>

                                            <Popconfirm
                                                title="Decline Pool Request!"
                                                description="Are you sure to decline this pool?"
                                                icon={
                                                    <QuestionCircleOutlined
                                                        style={{
                                                            color: 'red',
                                                        }}
                                                    />
                                                }
                                                okText="Yes"
                                                onConfirm={() => handlePoolRequest(item.pool_id, 'decline')}
                                            >
                                                <Button
                                                    key={item.pool_id}
                                                    className='pooling-notification-status-button pooling-notification-decline pooling-notification-button'
                                                    onClick={() => console.log("filter.value")}
                                                    icon={<StopOutlined />}
                                                >
                                                    Decline
                                                </Button>
                                            </Popconfirm>
                                        </div>
                                        : user.role == "Admin Pooling Agent" && item.is_approved_by_admin == false && item.status == "pending" && item.current_status=="active"
                                            ?
                                            <div className='pooling-notifications-footer-container'>
                                                <Popconfirm
                                                    placement="top"
                                                    title="Accept Pool Request!"
                                                    description="Do you really want to accept this request?"
                                                    okText="Yes"
                                                    cancelText="Cancel"
                                                    onConfirm={() => handlePoolRequest(item.pool_id, 'approved')}
                                                >
                                                    <Button
                                                        key={item.pool_id}
                                                        className='pooling-notification-status-button pooling-notification-green pooling-notification-button'
                                                        icon={<CheckOutlined />}
                                                    >
                                                        Accept
                                                    </Button>
                                                </Popconfirm>

                                                <Popconfirm
                                                    title="Decline Pool Request!"
                                                    description="Are you sure to decline this pool?"
                                                    icon={
                                                        <QuestionCircleOutlined
                                                            style={{
                                                                color: 'red',
                                                            }}
                                                        />
                                                    }
                                                    okText="Yes"
                                                    onConfirm={() => handlePoolRequest(item.pool_id, 'decline')}
                                                >
                                                    <Button
                                                        key={item.pool_id}
                                                        className='pooling-notification-status-button pooling-notification-decline pooling-notification-button'
                                                        onClick={() => console.log("filter.value")}
                                                        icon={<StopOutlined />}
                                                    >
                                                        Decline
                                                    </Button>
                                                </Popconfirm>
                                            </div>
                                            : item.current_status=="active" ? <div className='pooling-notifications-footer-container'>
                                                    <p className={`pooling-notifications-footer-admin-status ${item.is_approved_by_admin === true ? 'pooling-notifications-footer-admin-status-green' : 'pooling-notifications-footer-admin-status-red'}`}>{item.is_approved_by_admin === true ? "Approved" : "Pending For Admin Approval"}</p>
                                                    { item.is_approved_by_admin ? <p className='pooling-notifications-footer-admin-mail'>by @<span>{item.accepted_by}</span></p> : ""} 
                                                </div>
                                            : ""
                                            
                                } */}
                                {/* {item?.user_imo.length > 0 ?
                                <div className="imo-numbers-container" style={{color:"#678DFF"}}>
                                Nominated IMO No. -
                                    <div>
                                        {item.user_imo.map((imo, idx) => (
                                            <Tag color="gold" key={idx}>
                                                {imo}
                                            </Tag>
                                        ))}
                                    </div>
                                </div>
                                    : ""
                                } */}
                            

                            </div>

                        </div>
                    </div>
                ))
            )}
            {isPoolDetailsModalOpen && (
            <AutoPoolDetailsModal key={modalKey} poolId={poolId} setAdminAction={setAdminAction} adminAction={adminAction} userRole={user.role} handlePoolRequest={handlePoolRequest} notification_status={notification_status} PoolDetailsData={PoolDetailsData} isVisible={isPoolDetailsModalOpen} onClose={handlePoolDetailClose} setIsPoolDetailsModalOpen={setIsPoolDetailsModalOpen}/>
          )}
        </div>
        

    );
};

export default NotificationMainTable;
